import type { AppVueRouter } from '@modules/core/services/router/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import {
  ADMIN_FINANCE_ROUTE_NAME,
  AFFILIATE_FINANCE_ROUTE_NAME,
  FINANCE_PERMISSIONS,
} from '@modules/finance/constants';
import { FinanceMonthDeductionModule } from '@modules/finance/submodules/month-report/submodules/deduction/FinanceMonthDeductionModule';

import {
  ADMIN_FINANCE_MONTH_LIST_ROUTE_NAME,
  ADMIN_FINANCE_MONTH_ROUTE_NAME,
  AFFILIATE_FINANCE_MONTH_LIST_ROUTE_NAME,
  AFFILIATE_FINANCE_MONTH_ROUTE_NAME,
} from './constants';

export class FinanceMonthReportModule extends AppModule {
  protected submodules = [new FinanceMonthDeductionModule()];

  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_FINANCE_ROUTE_NAME, {
      name: ADMIN_FINANCE_MONTH_ROUTE_NAME,
      path: 'month_report/:date',
      permission: FINANCE_PERMISSIONS.SHOW,
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      props: {
        keepAliveInclude: 'FinanceMonthListPage',
      },
    });

    router.addChildRoute(ADMIN_FINANCE_MONTH_ROUTE_NAME, {
      name: ADMIN_FINANCE_MONTH_LIST_ROUTE_NAME,
      path: '',
      permission: FINANCE_PERMISSIONS.SHOW,
      component: () => import('./pages/FinanceMonthListPage/FinanceMonthListPage.vue'),
    });

    router.addChildRoute(AFFILIATE_FINANCE_ROUTE_NAME, {
      name: AFFILIATE_FINANCE_MONTH_ROUTE_NAME,
      path: 'month_report/:date',
      permission: FINANCE_PERMISSIONS.SHOW,
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      props: {
        keepAliveInclude: 'FinanceMonthListPage',
      },
    });

    router.addChildRoute(AFFILIATE_FINANCE_MONTH_ROUTE_NAME, {
      name: AFFILIATE_FINANCE_MONTH_LIST_ROUTE_NAME,
      path: '',
      permission: FINANCE_PERMISSIONS.SHOW,
      component: () => import('./pages/FinanceMonthListPage/FinanceMonthListPage.vue'),
    });
  }

  addMenu(): void {
  }

  addTranslationKeys(): void {
  }
}
